module.exports = __webpack_public_path__ + "static/media/7.c3d73f97.jpg";